import React from "react";
import "../theme/SkeletonIndicators.css";

/**
 * Skeleton para tarjeta de Ventas (fondo verde)
 * Muestra la estructura de la tarjeta mientras se cargan los datos
 */
export const SkeletonSalesCard = () => {
  return (
    <div className="skeleton-sales-card">
      {/* Header */}
      <div className="skeleton-sales-header">
        <div className="skeleton-sales-icon-section">
          <div className="skeleton-icon"></div>
          <div className="skeleton skeleton-text short" style={{ width: "80px" }}></div>
        </div>
        <div className="skeleton skeleton-amount"></div>
      </div>

      {/* Body */}
      <div className="skeleton-sales-body">
        {/* Columna 1: Vs Ptto */}
        <div className="skeleton-sales-column">
          <div className="skeleton skeleton-label"></div>
          <div className="skeleton skeleton-percentage"></div>
          <div className="skeleton skeleton-amount" style={{ width: "100px" }}></div>
        </div>

        {/* Columna 2: Vs Cuota */}
        <div className="skeleton-sales-column">
          <div className="skeleton skeleton-label"></div>
          <div className="skeleton skeleton-percentage"></div>
          <div className="skeleton skeleton-amount" style={{ width: "100px" }}></div>
        </div>

        {/* Columna 3: Vs AA */}
        <div className="skeleton-sales-column">
          <div className="skeleton skeleton-label"></div>
          <div className="skeleton skeleton-percentage"></div>
          <div className="skeleton skeleton-amount" style={{ width: "100px" }}></div>
        </div>
      </div>
    </div>
  );
};
